module.exports = __webpack_public_path__ + "img/8fc4c4e.png";